import siteConfig from "site-config";
import { Boards as BoardsSchema, BoardPermission as PermissionsSchema } from "schemas/whiteboard";
import querystring, { ParsedUrlQueryInput } from "querystring";
import { PAGE_LIMIT } from "constants/whiteboard";
interface IQuery extends ParsedUrlQueryInput {
    limit: number;
    min_identity?: string;
}

export interface ICreateBoardQueryData {
    board_name?: string;
}

export const getBoardQuery = (id) => {
    return {
        force: true,
        url: `${siteConfig.goAPI}/v1/boards/${id}`,
    };
};

export const getBoardPageQuery = (boardId, pageId) => {
    return {
        force: true,
        url: `${siteConfig.goAPI}/v1/boards/${boardId}/pages/${pageId}`,
    };
};

export const createBoardQuery = (body: ICreateBoardQueryData) => {
    return {
        body,
        force: true,
        options: {
            method: "POST",
        },
        schema: BoardsSchema,
        url: `${siteConfig.goAPI}/v1/boards`,
    };
};

export const getBoardPermissions = (boardId: string, minIdentity?: string | null) => {
    const query: IQuery = {
        limit: PAGE_LIMIT,
    };

    if (minIdentity) {
        query.min_identity = minIdentity;
    }

    return {
        force: true,
        schema: PermissionsSchema,
        update: {
            boardPermission: (prevEntities, nextEntities) => {
                if (minIdentity) {
                    // Ugly as sin, but we need to combine the permissions return on future paginated calls
                    // Page size is large enough we really dont have to do this very often, in theory
                    const previousBoardPermissions = prevEntities[boardId];
                    const nextBoardPermissions = nextEntities[boardId];
                    let allPermissions = previousBoardPermissions.users.concat(nextBoardPermissions.users);
                    allPermissions = allPermissions
                        .groupBy((permission) => permission.identity)
                        .map((user) => user.first())
                        .toList();
                    const permissions = previousBoardPermissions.set("users", allPermissions);
                    prevEntities[boardId] = permissions;
                    return {
                        ...prevEntities,
                    };
                } else {
                    return {
                        ...nextEntities,
                    };
                }
            },
        },
        url: `${siteConfig.goAPI}/v1/boards/${boardId}/permissions?${querystring.stringify(query)}`,
    };
};

export const deleteBoardPermission = ({ board_id, identity, identity_type = "USER", role = "VIEWER" }) => {
    return {
        force: true,
        options: {
            method: "DELETE",
        },
        schema: PermissionsSchema,
        update: {
            boardPermission: (prevEntities, nextEntities) => {
                // Ugly as sin, but we need to combine the permissions return on future paginated calls
                // Page size is large enough we really dont have to do this very often, in theory
                const previousBoardPermissions = prevEntities[board_id];
                const nextBoardPermissions = nextEntities[board_id];
                const filteredPermissions = previousBoardPermissions.users.filter((user) => {
                    return user.identity !== identity;
                });
                const permissions = previousBoardPermissions.set("users", filteredPermissions);
                prevEntities[board_id] = permissions;
                return {
                    ...prevEntities,
                };
            },
        },
        url: `${siteConfig.goAPI}/v1/boards/${board_id}/permissions/${identity}/${role}`,
    };
};

export const deleteBoardQuery = (boardId) => {
    return {
        force: true,
        options: {
            method: "DELETE",
        },
        url: `${siteConfig.goAPI}/v1/boards/${boardId}`,
    };
};

export const fetchBoardsQuery = (userId, minBoardId?, limit = 25) => ({
    force: true,
    schema: BoardsSchema,
    url: `${siteConfig.goAPI}/v1/users/${userId}/boards?limit=${limit}${
        minBoardId ? `&min_board_id=${minBoardId}` : ""
    }`,
});
